const LoadingSpinner = () => {
    return (
        <div className="flex flex-col justify-center items-center h-screen bg-white">
            <div className="flex flex-col items-center p-6 bg-white border-2 border-solid border-gray-100 rounded-xl shadow-lg">
                <div className="relative w-20 h-20">
                    <div className="absolute inset-0 border-4 border-dashed border-[#eb5527] rounded-full animate-spin-slow"></div>
                    <div className="absolute inset-2 border-4 border-solid border-[#eb5527] rounded-full animate-pulse-fade"></div>
                    <div className="absolute inset-0 flex justify-center items-center">
                        <img
                            src="https://console-d.com/logo.png"
                            alt="Loading Icon"
                            className="w-12 h-12 object-contain"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://placehold.co/48x48/CCCCCC/000000?text=Icon";
                            }}
                        />
                    </div>
                </div>
                <p className="mt-6 text-xl font-semibold text-gray-700 animate-bounce-text">
                    Loading content ...
                </p>
            </div>

            <style jsx>{`
                @keyframes spin-slow {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                @keyframes pulse-fade {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.5; transform: scale(0.95); }
                }

                @keyframes bounce-text {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-5px); }
                }

                .animate-spin-slow {
                    animation: spin-slow 2s linear infinite;
                }

                .animate-pulse-fade {
                    animation: pulse-fade 1.5s ease-in-out infinite;
                }

                .animate-bounce-text {
                    animation: bounce-text 1s infinite alternate;
                }
                `}
            </style>
        </div>
    );
};

export default LoadingSpinner;
